import { render, staticRenderFns } from "./profileAddresses.vue?vue&type=template&id=28a306b3&scoped=true"
import script from "./profileAddresses.vue?vue&type=script&lang=js"
export * from "./profileAddresses.vue?vue&type=script&lang=js"
import style0 from "./profileAddresses.vue?vue&type=style&index=0&id=28a306b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a306b3",
  null
  
)

export default component.exports